import { isCustomizedType, isNullOrUndefined, reduce } from "et3-type-guards";

import configuration from "../../configuration/keys/index";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import getCoreDeviceStore from "../../stores/core/core-device-store";
import { TAdminRole, TSignInData } from "../../Types";
import { post } from "../axios-post";

export const apiCallSignIn = async ({
  username,
  password
}: {
  username: string;
  password: string;
}): Promise<{
  data: TSignInData;
  status: string;
  code: Ti18nKeys;
}> => {
  const {
    isBrowser,
    isSmartTV,
    isTablet,
    isMobile,
    browserMajorVersion,
    browserFullVersion,
    browserName,
    engineName,
    engineVersion,
    osName,
    osVersion,
    userAgent,
    os
  } = getCoreDeviceStore().getDeviceData();
  const { data, status, et3Error } = await post<{
    adminInfo: {
      id: number;
      username: string;
      lastLogin: string;
      role: TAdminRole;
      fullName: string;
    };
    adminPermissions: {
      moduleId: number;
      description: string;
      hasPermission: 0 | 1;
    }[];
    needResetPassword: boolean;
  }>(`core/checkCredentials`, {
    username,
    password,
    adminVersion: configuration.version,
    deployedOn: configuration.date,
    environment: configuration.env,
    isBrowser: isNullOrUndefined(isBrowser) ? "NO_DATA" : `${isBrowser}`,
    isSmartTV: isNullOrUndefined(isSmartTV) ? "NO_DATA" : `${isSmartTV}`,
    isTablet: isNullOrUndefined(isTablet) ? "NO_DATA" : `${isTablet}`,
    isMobile: isNullOrUndefined(isMobile) ? "NO_DATA" : `${isMobile}`,
    browserMajorVersion: isNullOrUndefined(browserMajorVersion)
      ? "NO_DATA"
      : `${browserMajorVersion}`,
    browserFullVersion: isNullOrUndefined(browserFullVersion)
      ? "NO_DATA"
      : `${browserFullVersion}`,
    browserName: isNullOrUndefined(browserName) ? "NO_DATA" : `${browserName}`,
    engineName: isNullOrUndefined(engineName) ? "NO_DATA" : `${engineName}`,
    engineVersion: isNullOrUndefined(engineVersion)
      ? "NO_DATA"
      : `${engineVersion}`,
    osName: isNullOrUndefined(osName) ? "NO_DATA" : `${osName}`,
    osVersion: isNullOrUndefined(osVersion) ? "NO_DATA" : `${osVersion}`,
    userAgent: isNullOrUndefined(userAgent) ? "NO_DATA" : `${userAgent}`,
    os: isNullOrUndefined(os) ? "NO_DATA" : `${os}`
  });
  const emptyRole: TAdminRole = "";
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    const admin = reduce(() => data.adminInfo, {
      id: -1,
      username: "",
      lastLogin: "",
      role: "",
      fullName: ""
    });
    const id = reduce(() => admin.id, -1);
    const username = reduce(() => admin.username, "");
    const fullName = reduce(() => admin.fullName, "");
    const role = reduce(() => admin.role, "Customer Support");
    const lastLogin = reduce(() => admin.lastLogin, "");
    const adminPermissions = reduce(() => data.adminPermissions, []);
    const needResetPassword = reduce(() => data.needResetPassword, false);
    return {
      data: {
        id,
        username,
        fullName,
        role,
        lastLogin,
        adminPermissions,
        needResetPassword
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        id: -1,
        username: "",
        lastLogin: "",
        role: emptyRole,
        fullName: "",
        adminPermissions: [],
        needResetPassword: false
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        id: -1,
        username: "",
        lastLogin: "",
        role: emptyRole,
        fullName: "",
        adminPermissions: [],
        needResetPassword: false
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
